import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    input: {
      width: '100%',
    },
    button: {
      backgroundColor: COLORS.neutral.white,
      color: COLORS.gray.gray30,
      textTransform: 'capitalize',
      minWidth: 'min-content',
      '&:hover': {
        backgroundColor: COLORS.neutral.white,
      },
    },
    chevronIcon: {
      color: COLORS.gray.gray30,
    },
    inputStartAdornment: {
      paddingLeft: 0,
    },
    searchField: {
      border: 0,
    },
    iconSearch: {
      fontSize: theme.typography.pxToRem(16),
    },
    divider: {
      margin: theme.spacing(0, 1),
      height: 23,
      backgroundColor: COLORS.gray.gray60,
    },
    menuItem: {
      textTransform: 'capitalize',
    },
    body: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(-2),
      paddingRight: theme.spacing(2),
      maxHeight: 280,
      overflow: 'auto',
    },
    loader: {
      height: 124,
    },
  }),
  { name: 'ExternalChannelMenu' }
);
